<template>
  <el-row>
    <!-- Banner -->
    <el-row class="BannerContWidth">
      <el-col :span="24">
        <swiper class="my-swiper"
                v-if="showSwiper"
                ref="mySwiper"
                :options="swiperOption">
          <swiper-slide class="my-swiper-slide"
                        v-for="(item,index) in BannerImg"
                        :key="index">
            <img :src="item.title_url"
                 class="BannerImgBg swiper-lazy">
            <div class="BannerTextCont">
              <p class="BannerTextTitle">{{item.title}}</p>
            </div>
          </swiper-slide>
          <div slot="button-prev"
               class="swiper-button-prev hide"></div>
          <div slot="button-next"
               class="swiper-button-next hide"></div>
        </swiper>
        <!-- <el-carousel :height='BannerHeight+"px"'
                     style="cursor: pointer;">
          <el-carousel-item v-for="(item, ind) in BannerImg"
                            :key="ind">
            <div :style="'background-image: url(' + item.title_url +')'"
                 class="BannerImgBg"
                 @click="ToArticleDetails(item, 'Banner')">
              <img :src="item.title_url"
                   alt=""
                   ref='BannerHeight'
                   @load="setSize"
                   class="BannerImgBg">
              <div class="BannerTextCont">
                <div>
                  <p class="BannerTextTitle">{{item.title}}</p>
                </div>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel> -->
      </el-col>
    </el-row>
    <!-- 推荐 -->
    <el-row class="BannerContWidth ContMargin">
      <el-col :span="24">
        <el-col :span="16"
                :xs='24'>
          <!-- 热门游戏 -->
          <hotgamelist :content='GameListArr' />
          <QRCode v-if="!IsShow"
                  class="hidden-sm-and-up"></QRCode>
          <!-- 发现 -->
          <div class="TitleFont">
            <p>{{ $t('find') }}</p>
          </div>
          <div class="FindCont"
               v-for="(item, ind) in ArticleListData"
               :key="ind"
               @click="ToArticleDetails(item)">
            <p>{{$t('publishType.'+item.publish_type)}}</p>
            <img :src=" item.title_url">
            <div class="FindDetailsCont">
              <div class="FindDetails">
                <!-- <img src="../assets/images/a.png" alt=""> -->
                <div>
                  <p class="FindDetailsTitle">{{item.title}}</p>
                  <!-- <p class="BannerText SizeCol">{{item.content}}</p> -->
                </div>
              </div>
              <!-- <div class="ScoreNumCont">
                <p class="ScoreNum">8507人评分</p>
                <p class="Score">6.5</p>
              </div> -->
            </div>
          </div>
        </el-col>
        <!-- 二维码 -->
        <el-col :md="{span: 7,offset: 1}"
                :sm="{span: 8,offset: 0}"
                class="hidden-xs-only">
          <QRCode v-if="IsShow"></QRCode>
        </el-col>
      </el-col>
    </el-row>
    <foot></foot>
  </el-row>
</template>

<script>
import QRCode from '@/components/QRCode'
import hotgamelist from '@/components/module/gamelist'
import foot from '@/components/foot'
let vm
export default {
  name: 'Home',
  components: {
    QRCode, hotgamelist, foot
  },
  data () {
    return {
      showSwiper: false,
      swiperOption: {
        loop: true,
        speed: 1000,//1秒切换完成
        autoplay: {
          disableOnInteraction: false,//触碰后自动切换也不会停止
          delay: 3000//3秒切换一次
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        mousewheel: true,//支持鼠标
        updateOnWindowResize: true,//默认当窗口(window) 尺寸发生变化时，比如屏幕旋转，Swiper会更新和重新计算(update和breakpoints等)
        on: {
          init: function () {
            let that = this;
            this.loopedSlides = vm.BannerImg.length - 1

            this.el.onmouseover = function () {
              that.navigation.$nextEl.removeClass('hide');
              that.navigation.$prevEl.removeClass('hide');
            }
            this.el.onmouseout = function () {
              that.navigation.$nextEl.addClass('hide');
              that.navigation.$prevEl.addClass('hide');
            }
          },
          tap: function (e) {
            // 这里有坑
            // 需要注意的是：this 指向的是 swpier 实例，而不是当前的 vue， 因此借助 vm，来调用 methods 里的方法 
            // console.log(this); // -> Swiper
            // 当前活动块的索引，与activeIndex不同的是，在loop模式下不会将 复制的块 的数量计算在内。            const realIndex = this.realIndex;
            // vm.handleClickSlide(realIndex); 
            // console.log(vm.BannerImg[this.realIndex])

            if (e.target.className == 'swiper-button-next') {
              return
            }
            if (e.target.className == 'swiper-button-prev') {
              return
            }
            vm.ToArticleDetails(vm.BannerImg[this.realIndex], 'Banner')
          }
        },
      },
      // AllUserInfo: null,
      // token: null,
      IsShow: true,
      BannerHeight: '400',
      screenWidth: 0,
      ArticleListData: null,
      BannerImg: [], // 轮播图列表
      GameListArr: [] // 全部游戏列表
    }
  },
  created () {
    vm = this;
    // if (this.$store.state.count != '') {

    //   this.AllUserInfo = this.$store.state.count
    // }

    // this.token = this.$store.state.token
    this.ArticleList()
    this.GetBannerList()
    this.gameListData()
    // eslint-disable-next-line no-unused-vars
    // let screenWidth = document.body.clientWidth // body宽度
    // let scrollWidth = window.innerWidth - document.body.clientWidth // 滚动条宽度
    // if (screenWidth < 768) {
    //   this.IsShow = false
    //   this.BannerHeight = '134'
    // } else {
    //   this.IsShow = true
    //   this.BannerHeight = '400'
    // }
    // window.onresize = () => {
    //   let screenWidth = document.body.clientWidth
    //   if (screenWidth + scrollWidth <= 768) {
    //     this.IsShow = false
    //     this.BannerHeight = '134'
    //   } else {
    //     this.IsShow = true
    //     this.BannerHeight = '400'
    //   }
    // }
  },
  mounted () {
    this.setSize()
    window.addEventListener('resize', () => {
      this.setSize()
    }, false)
  },
  methods: {
    setSize () {
      this.$nextTick(() => {
        // if (this.BannerHeight) {
        //   console.log(this.$refs.BannerHeight)
        //   this.BannerHeight = this.$refs.BannerHeight[0].height
        // }
      })
    },
    ArticleList () { // 获取文章列表
      this.$axios.get(this.apiUrl.API.GetContentList, {
        params: {
          pageNum: 0
        }
      })
        .then((res) => {
          this.ArticleListData = res.data.data
        })
    },
    gameListData () { // 获取游戏列表
      this.$axios.get(this.apiUrl.API.GameList)
        .then((res) => {
          //res.data.data = [{ "game_name": "Cuộc Chiến Vương Quyền", "logo_url": "finalFilesUpload/imgfilesupload/20200429/a855887d201b4fe48b858a4ab95b38f2.jpg", "serial_number": 4, "add_time": "2020-04-30  03:55:50", "game_id": "LIE_WANG_D-SOLAPLAY" }, { "game_name": "Light of Thel: Thời Hoàng Kim", "logo_url": "finalFilesUpload/imgfilesupload/20200424/d721288f5fe74ec5bbe06834636a1373.png", "serial_number": 3, "add_time": "2020-04-30  03:55:31", "game_id": "SAI_ER_Z_G_D-SOLAPLAY" }, { "game_name": "Tân Tam Quốc Chí", "logo_url": "finalFilesUpload/imgfilesupload/20200428/7cf19a0361a84e38b45ff09a5c808853.png", "serial_number": 2, "add_time": "2020-04-28  15:26:54", "game_id": "BBG_D-SOLAPLAY" }, { "game_name": "Yong Heroes", "logo_url": "finalFilesUpload/imgfilesupload/20200428/2265d10d4a58446eb8e5b9fc33ef3438.jpg", "serial_number": 1, "add_time": "2020-04-30  03:55:41", "game_id": "1567996030589280-SOLAPLAY" }, { "game_name": "Yong Heroes", "logo_url": "finalFilesUpload/imgfilesupload/20200428/2265d10d4a58446eb8e5b9fc33ef3438.jpg", "serial_number": 1, "add_time": "2020-04-30  03:55:41", "game_id": "1567996030589280-SOLAPLAY" }, { "game_name": "Yong Heroes", "logo_url": "finalFilesUpload/imgfilesupload/20200428/2265d10d4a58446eb8e5b9fc33ef3438.jpg", "serial_number": 1, "add_time": "2020-04-30  03:55:41", "game_id": "1567996030589280-SOLAPLAY" }, { "game_name": "Yong Heroes", "logo_url": "finalFilesUpload/imgfilesupload/20200428/2265d10d4a58446eb8e5b9fc33ef3438.jpg", "serial_number": 1, "add_time": "2020-04-30  03:55:41", "game_id": "1567996030589280-SOLAPLAY" }]
          this.GameListArr = res.data.data;
        })
    },
    GetBannerList () { // 获取轮播图列表
      this.$axios.get(this.apiUrl.API.GetBanner)
        .then((res) => {
          this.BannerImg = res.data.data;
          this.showSwiper = true;
        })
    },
    ToArticleDetails (id, Cla) { // 跳转至详情
      let url
      //game_id==''跳转文章或banner详情页.不为空就去下面判断is_jump
      if (id.game_id == '') {
        if (Cla) {
          url = `/ArticleDetails?id=${id.announcement_id}&Cla=${Cla}`
        } else {
          url = `/ArticleDetails?id=${id.announcement_id}`
        }
      } else {
        //is_jump==0展示文章或banner详情+相关内容
        //is_jump==1跳到游戏详情
        if (id.is_jump == 0) {
          if (Cla) {
            url = `/ArticleDetails?id=${id.announcement_id}&Cla=${Cla}&gameId=${id.game_id}`
          } else {
            url = `/ArticleDetails?id=${id.announcement_id}&gameId=${id.game_id}`
          }
        } else {
          url = `/product?id=${id.game_id}`
        }

      }
      this.$router.push({
        path: url
      })
    }
  }
}
</script>

<style scoped>
/* 左右按钮显示隐藏效果 */
.swiper-container .hide {
  opacity: 0;
}
.swiper-button-next,
.swiper-button-prev {
  transition: opacity 0.5s;
}

.my-swiper-slide {
  cursor: pointer;
}
.BannerContWidth {
  width: 1040px;
  display: flex;
  margin-top: 1.667rem;
  margin: 20px auto 0 auto;
  border-radius: 3px;
  overflow: hidden;
}
.BannerImgBg {
  width: 100%;
  border-radius: 3px;
}
.BannerTextCont {
  width: 100%;
  height: 70px;
  line-height: 70px;
  position: absolute;
  left: 0;
  bottom: 3px;
  display: flex;
  text-indent: 1.5rem;
  background: rgba(201, 201, 201, 0.5);
}
.BannerTextTitle {
  font-size: 16px;
  color: #fff;
  font-weight: 700;
}
.BannerText {
  font-size: 1.167rem;
}
.ContMargin {
  margin-top: 0;
}
.TitleFont {
  font-size: 1.333rem;
  padding-bottom: 10px;
  margin: 1.333rem 0 0 0;
  /* border-bottom: 1px solid #ddd; */
}
.TitleFont > p {
  color: #333;
  padding-left: 8px;
  border-left: 0.5rem solid #ff7473;
}

.FindCont {
  width: 100%;
  margin: 0 0 15px 0;
  cursor: pointer;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.05);
  border-radius: 3px;
  overflow: hidden;
}
.FindCont > p {
  font-size: 14px;
  line-height: 20px;
  padding: 10px 15px;
  color: #999;
  background: #fff;
}
.FindCont > img {
  width: 100%;
  display: block;
}
.FindDetailsCont {
  width: 100%;
  background: white;
  display: flex;
  justify-content: space-between;
}
.FindDetails {
  display: flex;
  padding: 1rem 0;
  line-height: 2.333rem;
  padding-left: 0.833rem;
}
.FindDetailsTitle {
  font-size: 16px;
  line-height: 28px;
  color: #333;
  font-weight: 700;
}
.FindDetails > img {
  width: 4.75rem;
  height: 4.75rem;
  margin-right: 1rem;
  border-radius: 1rem;
}
.SizeCol {
  color: #999;
}
.ScoreNumCont {
  text-align: right;
  padding-right: 0.833rem;
}
.ScoreNum {
  font-size: 1rem;
  color: #14b8c7;
  padding-top: 1.4rem;
}
.Score {
  padding-top: 0.4rem;
  font-size: 1.333rem;
  color: #14b8c7;
}

@media (max-width: 1200px) {
  .BannerContWidth {
    width: 88%;
  }
}
@media (max-width: 992px) {
  .BannerContWidth {
    width: 84%;
  }
}
@media (max-width: 768px) {
  .BannerContWidth {
    width: 82%;
  }
}
@media (max-width: 576px) {
  .BannerContWidth {
    width: 90%;
  }
  .HotsGameCont {
    display: -webkit-box;
    overflow: initial;
  }
  .BannerTextCont {
    height: 35px;
    line-height: 35px;
  }
  /* .FindCont > img {
    height: 150px;
  } */
  .BannerTextCont p {
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue